import { z } from 'zod';

export const updateSiteSchema = z.object({
  name: z.string().min(1).max(120).optional(),
  theme: z.string().min(1).max(80).optional(),
});

export const subdomainSchema = z
  .string()
  .min(3)
  .max(40)
  .regex(/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/);
